import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import PlayBehaviorService from './PlayBehaviorService';
import PlayBehaviorCommonForm from './Form/PlayBehaviorCommonForm';


class PlayBehaviorModal extends Component {
    constructor(props) {
        super(props);

        // Get play behavior early
        this.state = {
            isModalOpen: false,
            selectedPlayBehavior: null,
            userPlayBehaviors: null
        };

        const playBehaviorService = new PlayBehaviorService();

        playBehaviorService.getCurrentPlayBehavior().then(currentPlayBehavior => {
            this.setState({ selectedPlayBehavior: currentPlayBehavior })
        })

        // playBehaviorService.getUserPlayBehaviors().then(playBehaviors => {
        //     console.log(playBehaviors)
        //     this.setState({ userPlayBehaviors: playBehaviors })
        // })
    }

    closeModal = () => {
        this.setState({
            isModalOpen: false
        });
    }

    openModal = () => {
        this.setState({
            isModalOpen: true
        });
    }

    save = () => {
    }

    render() {
        const CustomTooltip = ({ active, payload, label }) => {
            if (active) {
                return (
                <div className="custom-tooltip">
                    <p className="label"><b>{`${payload[0].payload.name}`}</b></p>
                    <p className="label">Chance of being played:<br/>{payload[0].value}%</p>
                </div>
                );
            }
          
            return null;
        };

        const YAxisLabel = () => {
            return (
              <text x={-125} y={30} transform={`rotate(270)`} textAnchor="middle">
                {`Chances of Playing (%)`}
              </text>
            );
        };

        const XAxisLabel = () => {
            return (
              <text x={350} y={300} textAnchor="middle">
                Hand Rank
              </text>
            );
        };

        const xTicks = Array.from({ length: 9}, (_, i) => 0 + (i*20))
        const yTicks = Array.from({ length: 6}, (_, i) => 0 + (i*20))

        return (
            <div className="mt-5 mb-5">
                {   this.state.selectedPlayBehavior &&
                    <div>
                        <div className="text-center mt-4 mb-4">
                            <p>
                                Hand-Range Model: {this.state.selectedPlayBehavior.name}
                            </p>
                            <Button onClick={this.openModal}>
                                View
                            </Button>
                        </div>
                        <Modal show={this.state.isModalOpen} onHide={this.closeModal} size="lg">
                            <Modal.Header closeButton className="App-header">
                                <strong>View {this.state.selectedPlayBehavior.name}</strong>
                            </Modal.Header>
                            <Modal.Body className="p-5 text-center">
                                <h6>
                                    Model Plot
                                </h6>
                                <ResponsiveContainer width="100%" height={300} >
                                    <LineChart  data={this.state.selectedPlayBehavior.probRankList}
                                        height={400}
                                        margin={{
                                            top: 20,
                                            right: 20,
                                            bottom: 20,
                                            left: 20,
                                        }}>
                                        <XAxis type="number" dataKey="rank" domain={[0, 180]} ticks={xTicks} label={<XAxisLabel/>}/>
                                        <YAxis ticks={yTicks} label={<YAxisLabel/>}/>
                                        <CartesianGrid strokeDasharray="3 3"/>
                                        <Tooltip content={<CustomTooltip/>}/>
                                        <Line type="monotone" dataKey="prob" stroke="#8884d8" dot={false}/>
                                    </LineChart>
                                </ResponsiveContainer>

                                <div className="pb-4"></div>

                                <hr/>
                                <div className="mt-4">
                                    <h6 className="mb-4">
                                        Model Details
                                    </h6>
                                    <PlayBehaviorCommonForm selectedPlayBehavior={this.state.selectedPlayBehavior}/>
                                </div>

                            </Modal.Body>
                            <Modal.Footer>
                                {/* <Button onClick={this.save}>
                                    Save
                                </Button> */}
                                <Button variant="secondary" onClick={this.closeModal}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                }
            </div>
        )
    }
}

export default PlayBehaviorModal;
